var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"movie"},[_c('PpvToast'),(_vm.isWavviePopupShow)?_c('wavvie-popup',{attrs:{"close-fn":_vm.popupClose}}):_vm._e(),_c('super-multi-section'),_vm._m(0)],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ppv-notice"},[_c('p',[_vm._v("Wavvie 영화관은 PLAYY가 제공하는 영화를 포함하고 있습니다.")])])
}]

export { render, staticRenderFns }